/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { UpdateBuchungForTimeframeDto } from '../../models/update-buchung-for-timeframe-dto';

export interface UpdateBuchungenForTimeframe$Json$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  
    /**
     * Daten für die Buchung
     */
    body?: UpdateBuchungForTimeframeDto
}

export function updateBuchungenForTimeframe$Json(http: HttpClient, rootUrl: string, params: UpdateBuchungenForTimeframe$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, updateBuchungenForTimeframe$Json.PATH, 'put');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungDto>>;
    })
  );
}

updateBuchungenForTimeframe$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/buchungen/timeframe';
